<template>
    <div :class="'first-page ' + (this.show_glove ? 'active' : '')">
        <div class="wrapper">
            <div class="glove"></div>

            <div class="links" @mouseenter="showGlove" @mouseleave="hideGlove">
                <div class="lang fr" >
                    <router-link to="/fr/">
                        <h2>Entrer</h2>
                        Site et boutique en français
                    </router-link>
                </div>
                <div class="lang en">
                    <router-link to="/en">
                        <h2>Enter</h2>
                        English website and shop
                    </router-link>
                </div>
            </div>

            <img src="../assets/amelie_title.png" alt="Amelie de Chassey"/>
            <p>Suivez notre actualité sur <a :href="facebookUrl" target="_blank">facebook</a></p>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'home page',
    data() {
      return {
        show_glove: false,
        facebookUrl: 'https://www.facebook.com/Les-Gants-dAm%C3%A9lie-309750282382568/',
      };
    },
    methods: {

      showGlove() {
        this.show_glove = true;
      },
      hideGlove() {
        this.show_glove = false;
      },

    },
  };
</script>

<style lang="scss">
    @keyframes popBG {
        from {opacity:0}
        to {opacity:1}
    }




    .first-page {
        background: url('../assets/homepage_bg.jpg') no-repeat top;
        animation: popBG 1s ease;
        display: flex;
        vertical-align: middle;
        height:1024px;
        width:1280px;
        max-width: calc(100vw - 16px);


        &.active {
            @media screen and (min-width:400px) {
                background-image: url('../assets/homepage_bg_hover.jpg');
            }
        }

        .wrapper {
            display: inline-block;
            margin: auto;

            .glove {
                height:550px;
                opacity:0;
            }
        }



        .links {
            display: flex;
            margin-bottom:2rem;

            @media screen and (max-width:400px){
                flex-direction: column;
                text-align: center;

                .lang:first-child {
                    margin-top:-3rem;

                }
            }

            .lang{

                &:first-child{
                    @media screen and (min-width:400px) {
                        text-align: right;
                        margin-right: 1rem;
                    }
                }

                a {

                    background-color: transparent;
                    font-family: 'EB Garamond', serif;
                    color: #9c554b;

                    text-decoration: none;

                    &:hover{
                        h2 {
                            color:white;
                            transition: color 0.5s ease;
                        }
                    }

                    h2 {
                        text-transform: uppercase;
                        margin: 0;
                    }
                }
            }
        }

        p {
            color:white;
            font-size:0.8rem;
            text-align:center;
            a {
                color:inherit;
                font-size:1rem;
                font-weight: bold;
            }
        }

    }
</style>


// WEBPACK FOOTER //
// src/components/FirstPage.vue